import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { KeyValue } from '../models/common';
import {
  SaveInsurerCompanyBySupervisor,
  SaveSupervisorRequest,
  SupervisorFilterRequest,
  DeleteSupervisorInsurerRequest
} from '../models/request/supervisorRequest';
import {
  InsurerBySupervisorResponse,
  SupervisorDataResponse,
  SupervisorResponse
} from '../models/response/supervisorResponse';

const baseRoute: string = 'Supervisor';

export class SupervisorApi {
  getDomain(
    request: SupervisorFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getSupervisor(
    request: SupervisorFilterRequest
  ): Promise<AxiosResponse<SupervisorResponse>> {
    return api.get(`${baseRoute}`, { params: request });
  }

  save(
    request: SaveSupervisorRequest
  ): Promise<AxiosResponse<Result<SupervisorDataResponse>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  getSupervisorData(
    request: SupervisorFilterRequest
  ): Promise<AxiosResponse<Result<SupervisorDataResponse>>> {
    return api.get(`${baseRoute}/getsupervisordata`, { params: request });
  }

  getAllInsurerBySupervisor(supervisorGuid: string, guidInsurerCompany: string): Promise<AxiosResponse<Result<InsurerBySupervisorResponse[]>>> {
    return api.get(`Supervisor_Insurer/getallinsurerbysurpervisor`, {params: {guidSupervisor: supervisorGuid, guidInsurerCompany: guidInsurerCompany }})
  }

  saveInsurerCompanyBySupervisor(request: SaveInsurerCompanyBySupervisor): Promise<AxiosResponse<Result<InsurerBySupervisorResponse[]>>>{
    return api.post(`Supervisor_Insurer/saveinsurerbysurpervisor`, request)
  }

  inactiveInsurerBySurpervisor(request: DeleteSupervisorInsurerRequest): Promise<AxiosResponse> {
    return api.post(`Supervisor_Insurer/inactiveinsurerbysurpervisor`, request)
  }
}

export const supervisorApi = new SupervisorApi();
